import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions } from 'chart.js';
import { CHART_CONFIG } from '@core/constants/chartConfig.ts';

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

interface PieChartData {
    value: number;
    name: string;
}

interface PieChartWithLegendProps {
    data?: PieChartData[];
    colors?: string[];
    style?: React.CSSProperties;
}

const PieChartWithLegend: React.FC<PieChartWithLegendProps> = ({
    data = [
        { value: 700, name: 'Product A' },
        { value: 300, name: 'Product B' },
        { value: 247, name: 'Product C' },
        { value: 379, name: 'Product E' }
    ],
    colors = [
        CHART_CONFIG.color.primary,
        CHART_CONFIG.color.danger,
        CHART_CONFIG.color.warning,
        CHART_CONFIG.color.success
    ],
    style
}) => {
    const options: ChartOptions<'pie'> = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'right',
                labels: {
                    color: 'rgba(0, 0, 0, 1)',
                    usePointStyle: true,
                    padding: 15
                }
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const label = context.label || '';
                        const value = context.parsed;
                        const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
                        const percentage = ((value / total) * 100).toFixed(1);
                        return `${label}: ${value} (${percentage}%)`;
                    }
                }
            }
        },
        animation: {
            animateScale: true,
            animateRotate: true,
            duration: 2000
        },
        elements: {
            arc: {
                borderWidth: 0
            }
        }
    };

    const chartData = {
        labels: data.map((item) => item.name),
        datasets: [
            {
                data: data.map((item) => item.value),
                backgroundColor: colors,
                hoverBackgroundColor: colors.map((color) => color),
                hoverBorderWidth: 3,
                hoverBorderColor: '#ffffff'
            }
        ]
    };

    return (
        <div style={{ width: '100%', height: '350px', ...style }}>
            <Pie data={chartData} options={options} />
        </div>
    );
};

export default PieChartWithLegend;
